export const BASE_URL = 'https://backendapp.tasscofarms.online/api/';
export const IMAGE_PATH = 'https://backendapp.tasscofarms.online';

//  export const BASE_URL = 'http://localhost:9090/api/';
//  export const IMAGE_PATH = 'http://localhost:9090';


